<template>
   <div v-if="text" class="dream-description">
      <p class="text-grey">{{title}}</p>
      <h6 > {{text}}</h6>
   </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: false,
    },
  },
}
</script>

<style scoped>
.dream-description__title {
  font-weight: bold;
}
</style>
